import { connect } from 'react-redux';
import { fetchCountry, selectSubdivisionName, selectIsFetchingCountry, selectIsLoadedCountry, selectIsToRefetchCountry } from '@gandi/redux-places';
import SubdivisionName from './components/SubdivisionName';
export const mapStateToProps = (state, ownProps) => ({
  isFetchingCountry: selectIsFetchingCountry(state, ownProps.country || ''),
  isLoadedCountry: selectIsLoadedCountry(state, ownProps.country || ''),
  isToRefetchCountry: selectIsToRefetchCountry(state, ownProps.country || ''),
  subdivisionName: selectSubdivisionName(state, {
    alpha2: ownProps.country || '',
    code: ownProps.subdivision
  })
});
const mapDispatchToProps = dispatch => ({
  fetchCountry: (...args) => dispatch(fetchCountry(...args))
});
export default connect(mapStateToProps, mapDispatchToProps)(SubdivisionName);